import { render, staticRenderFns } from "./uploadRechargeImg.vue?vue&type=template&id=74582c54&scoped=true&"
import script from "./uploadRechargeImg.vue?vue&type=script&lang=js&"
export * from "./uploadRechargeImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadRechargeImg.vue?vue&type=style&index=0&id=74582c54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74582c54",
  null
  
)

export default component.exports